import camelcaseKeys from "camelcase-keys";
import { useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import { AXIOS } from "hooks/axios";
import { useAuth } from "components/auth/AuthProvider";
import { useError } from "components/status/ErrorProvider";

export type LogsSchema = {
  host: string;
  updatedAt: string;
  data: string[];
  isTruncated: boolean;
};

export const usePavmLogs = (
  host: string,
  name: string,
  stream: boolean,
  updatedAt: {
    gte: string,
    lt: string
  },
  limit?: number,
) => {
  const { user } = useAuth();
  const { setError } = useError();

  const uri = user?.project?.uri;
  const limitKey = limit ? limit : "";

  return useQuery<
    AxiosResponse<any, any>,
    AxiosError<{ message: string }>,
    LogsSchema
  >(
    [`PAVM ${uri} HOST ${host} LOGS ${name} LIMIT ${limitKey}`],
    () => AXIOS.post<LogsSchema>(`${uri}/logs`, { host, name, limit, updatedAt }),
    {
      retry: 2,
      enabled: !!stream,
      staleTime: 0,
      refetchInterval: stream ? 1000 : false, // if stream === true, set refetch interval to 1 second
      select: (data) => camelcaseKeys(data.data as any, { deep: true }),
      onError: (err) => {
        const message = err?.response?.data?.message ?? "";
        setError({ message, reset: () => {} });
      },
    }
  );
};
